import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { View } from 'react-native';

import { useResponsive } from '@garnish/core';

import { VerifiedByIdMeArtwork } from '../../assets';

// ─────────────────────────────────────────────────────────────────────────────

export const IdMeVerifiedBadge = () => {
  const { formatMessage } = useIntl();
  const { match } = useResponsive();

  // ─── Styles ────────────────────────────────────────────────────────────────

  const artworkWidth = match([200, 190]);
  const artworkHeight = match([34, 32]);

  // ───────────────────────────────────────────────────────────────────────────

  return (
    <View accessible role="img" aria-label={formatMessage(messages.verifiedByIdMe)}>
      <VerifiedByIdMeArtwork width={artworkWidth} height={artworkHeight} />
    </View>
  );
};

// ─── Messages ────────────────────────────────────────────────────────────────

const messages = defineMessages({
  verifiedByIdMe: {
    defaultMessage: 'Verified by IDMe',
    description: 'ID.me | Verified badge alt text',
  },
});
